export const api = window._env_?.API_URL ?? process.env.REACT_APP_API_URL;
export const currency = window._env_?.CURRENCY ?? process.env.REACT_APP_CURRENCY;
